import axios from "axios";
import { PaginatedResult, PaginatedResultSummary } from "../models/pagination";
import { requests, responseBody } from "./Requests";
import { 
    AccountsReceivableAgingReportItemDto, 
    AccountsReceivableIndexItemDto, 
    AccountsReceivableReportItemDto, 
    ApplyARToOutstandingTicketRequestDto, 
    ExpandedARIndexItemTicketDto, 
    OutstandingTicketDto, 
    QueueStatusDto, 
    SettingsAccountsReceivableDTO, 
    UpsertAccountsReceivableDto 
} from "../models/accountsReceivable";

export const printAccountsReceivable = {
    queuePrintAllAccountsReceivableStatement: () => axios.get<QueueStatusDto>(`/AccountsReceivable/queuePrintAllAccountsReceivableStatement`).then(responseBody),
    queueCustomerAccountsReceivableStatement: (id: string) => axios.get<QueueStatusDto>(`/AccountsReceivable/queueCustomerPrintAccountsReceivableStatement/${id}`).then(responseBody),
    printAllAccountsReceivableStatement: () => axios.get<string>(`/AccountsReceivable/printAllAccountsReceivableStatements`).then(responseBody),
    printAccountsReceivableStatementForCustomer: (customerId: string) =>
        axios.get<string>(`/AccountsReceivable/printAccountsReceivableStatementForCustomer/${customerId}`)
            .then(responseBody),
}

export const accountsReceivable = {
    getOutstandingTickets: (customerId: string, params: URLSearchParams) => axios.get<PaginatedResultSummary<OutstandingTicketDto[]>>(`/AccountsReceivable/listOutstandingTickets/${customerId}`, { params }).then(responseBody),
    updateAccountsReceivable: (customerId: string, values: UpsertAccountsReceivableDto) => requests.put<void>(`/AccountsReceivable/updateAccountsReceivable/${customerId}`, values),
    addAccountsReceivable: (customerId: string, values: UpsertAccountsReceivableDto) => requests.post<void>(`/AccountsReceivable/addAccountsReceivable/${customerId}`, values),
    payForTickets: (values: ApplyARToOutstandingTicketRequestDto) => requests.post<void>(`/AccountsReceivable/payForTickets`, values),
}

export const accountsReceivableIndex = {
    getAccountsReceivableIndex: (params: URLSearchParams) =>
        axios.get<PaginatedResult<AccountsReceivableIndexItemDto[]>>('/AccountsReceivableIndex/getAccountsReceivableIndex', { params }).then(responseBody),
    getExpandedARIndexTickets: (customerId: string, params: URLSearchParams) =>
        axios.get<PaginatedResult<ExpandedARIndexItemTicketDto[]>>(`/AccountsReceivableIndex/getARIndexTickets/${customerId}`, { params }).then(responseBody),
};

export const accountsReceivableSettings = {
    getAccountsReceivableSettings: () => axios.get<SettingsAccountsReceivableDTO>(`/SettingsAccountsReceivable/getSettingsAccountsReceivable`, {}).then(responseBody),
    updateAccountsReceivableSettings: (values: SettingsAccountsReceivableDTO) => requests.put<void>(`/SettingsAccountsReceivable/updateSettingsAccountsReceivable/${values.id}`, values),
    addAccountsReceivableSettings: (values: SettingsAccountsReceivableDTO) => requests.post<void>(`/SettingsAccountsReceivable/addSettingsAccountsReceivable`, values),
};

export const accountsReceivableReports = {
    getAccountsReceivableReport: (params: URLSearchParams) => axios.get<AccountsReceivableReportItemDto[]>(`/AccountsReceivableReport`, { params }).then(responseBody),
    getAccountsReceivableAgingReport: (params: URLSearchParams) => axios.get<AccountsReceivableAgingReportItemDto[]>(`/AccountsReceivableReport/agingReport`, { params }).then(responseBody),
};
